import { createSlice } from "@reduxjs/toolkit";
import {   reKyc_email_verify_otpThunk } from "./thunk";

export const initialState = {
  reKyc_email_verify_otpData: [],
  reKyc_email_verify_otpError: '', // for error message
  reKyc_email_verify_otpLoading: false,
  
  
};

const Re_Kyc_Email_Verify_Otp = createSlice({
  name: "Re_Kyc_Email_Verify_Otp",
  initialState, 
  reducers: {}, 
  extraReducers: (builder) => {

    builder.addCase(reKyc_email_verify_otpThunk.pending, (state) => {
      state.reKyc_email_verify_otpLoading = true ;
      state.reKyc_email_verify_otpData= [];
      state.reKyc_email_verify_otpError='';

  });
    builder.addCase(reKyc_email_verify_otpThunk.fulfilled, (state, action) => {
        state.reKyc_email_verify_otpData = action.payload.data;
        state.reKyc_email_verify_otpLoading = false ;
    });
    builder.addCase(reKyc_email_verify_otpThunk.rejected, (state, action) => {
      state.reKyc_email_verify_otpError = action.error?.message || action.payload?.message || "An unknown error occurred";
        state.reKyc_email_verify_otpLoading = false ;
    });
}
});

export const {
  apiRequest,
  apiError,
  
  
} = Re_Kyc_Email_Verify_Otp.actions

export default Re_Kyc_Email_Verify_Otp.reducer;